import { Button, IconButton, Stack, styled, Typography } from '@mui/material';
import { HeaderClient } from '../Clients/conponents/HeaderClient';
import React from 'react';
import { useInjection } from './hook';
import { TableInfiniteScroll } from 'app/components/elements/TableInfiniteScroll';
import { Location, SearchType } from 'types/loctions';
import { DialogConfirm } from '../../components/elements/DialogConfirm';
import { TextEllipsis } from '../../components/elements/TextEllipsis';
import { useAuth } from 'contexts/auth';
import { Role } from 'const/common';
import {
  isRoomLocationLevel,
  isVerticalLocationLevel,
  renderTitle
} from 'utils/renderTitleLocation';
import { InputSelect } from '../../components/elements/InputSelect';
import { ModalReparentLocation } from './ModalReparentLocation';
import { ModalEditLocationName } from './ModalEditLocationName';

const optionSearchType = [
  { label: 'Partial Text', value: 'partial-text' },
  { label: 'Full text', value: 'full-text' }
];
export const LocationPage = () => {
  const {
    locations,
    fetchMoreData,
    hasMore,
    handleSearch,
    onSortHeader,
    searchParams,
    handleBack,
    paths,
    onClickAction,
    clientId,
    clientName,
    title,
    header,
    listButton,
    locationDelete,
    setLocationDelete,
    locationReparent,
    setLocationReparent,
    locationRename,
    setLocationRename,
    handleDeleteLocation,
    pathLastRoom,
    isFreeSearch,
    handleNavigateLastRoom,
    searchType,
    setSearchType,
    asyncGetInitLocations
  } = useInjection();
  const { auth } = useAuth();
  const isCanAccessRoom = auth?.role
    ? [Role.ADMIN, Role.SUPER_ADMIN, Role.VIEWER, Role.EDITOR, Role.MANAGER].includes(auth?.role)
    : false;
  const isCanAddRoom = auth?.role ? [Role.ADMIN, Role.SUPER_ADMIN].includes(auth?.role) : false;
  const renderDataMap = (locations: Location[]) => {
    return locations?.map((location) => {
      const isRoom = isRoomLocationLevel(location.level);
      return {
        name: {
          value: (
            <TextEllipsis
              onClick={() => {
                if (isRoom && !isCanAccessRoom) return;
                isRoom
                  ? onClickAction({
                      href: `/clients/${clientName}/${clientId}/location/${location.id}/room`,
                      path: location.name,
                      locationId: location.id
                    })
                  : onClickAction({
                      href: `/clients/${clientName}/${clientId}/location/${location.id}`,
                      path: location.name,
                      locationId: location.id
                    });
              }}
              text={
                isFreeSearch
                  ? `${location.name} - ${renderTitle(location.level).title}`
                  : location.name
              }
              styles={{ textDecoration: 'underline', cursor: 'pointer', color: '#226AAA' }}
              width={'80%'}
            />
          )
        },
        actions: {
          value: isRoom ? (
            <Stack flexDirection={'row'} gap={1}>
              <Button
                onClick={() => {
                  if (isRoom && !isCanAccessRoom) return;
                  onClickAction({
                    href: `/clients/${clientName}/${clientId}/location/${location.id}/room`,
                    path: location.name,
                    locationId: location.id
                  });
                }}>
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View
                </Typography>
              </Button>
              {isCanAddRoom && (
                <>
                  <Button onClick={() => setLocationRename(location)}>
                    <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                      Rename
                    </Typography>
                  </Button>
                  <Button onClick={() => setLocationReparent(location)}>
                    <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                      Move
                    </Typography>
                  </Button>
                  <IconButton
                    onClick={() => {
                      setLocationDelete(location);
                    }}>
                    <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />
                  </IconButton>
                </>
              )}
            </Stack>
          ) : (
            <Stack flexDirection={'row'} gap={1.25} flexWrap="wrap" alignItems="center">
              <Button
                onClick={() => {
                  onClickAction({
                    href: `/clients/${clientName}/${clientId}/location/${location.id}`,
                    path: location.name,
                    locationId: location.id
                  });
                }}>
                <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  View
                </Typography>
              </Button>
              {isCanAddRoom && (
                <>
                  <Button onClick={() => setLocationRename(location)}>
                    <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                      Rename
                    </Typography>
                  </Button>
                  <Button onClick={() => setLocationReparent(location)}>
                    <Typography sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
                      Move
                    </Typography>
                  </Button>
                  <IconButton
                    onClick={() => {
                      setLocationDelete(location);
                    }}>
                    <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />
                  </IconButton>
                </>
              )}
            </Stack>
          )
        }
      };
    });
  };
  return (
    <WrapperCreatePage>
      <HeaderClient
        onShowLastRoom={pathLastRoom ? handleNavigateLastRoom : undefined}
        buttons={listButton}
        title={title.title}
        // valueFilterType={searchParams.get('type') || ''}
        onSearch={handleSearch}
        // onFilterType={filterByTypeAccess}
        // onFilterClient={() => {}}
        // optionFilterClient={optionTypeAccess}
        // optionFilterType={optionTypeAccess}
        textButton={'Back'}
        isSearch={isFreeSearch}
        onClickButton={handleBack}
        paths={paths}
        isCanAccessRoom={isCanAddRoom}
      />
      <Stack style={{ width: 'fit-content', gap: '8px' }}>
        <Typography
          style={{
            fontWeight: '700',
            color: '#226AAA',
            whiteSpace: 'nowrap'
          }}>
          Search Type
        </Typography>
        <InputSelect
          style={{ minHeight: 'auto', height: '48px' }}
          value={searchType}
          onChange={(e) => setSearchType(e.target.value as SearchType)}
          options={optionSearchType}
        />
      </Stack>
      <Stack id={'id-table-clients'} sx={{ height: 'calc(100% - 230px)', overflow: 'scroll' }}>
        <TableInfiniteScroll
          sort={{
            field: searchParams.get('sortBy') || '',
            order: searchParams.get('order') || ''
          }}
          onSortHeader={onSortHeader}
          idElementScroll={'id-table-clients'}
          data={renderDataMap(locations)}
          handleFetchMore={fetchMoreData}
          headers={header}
          hasMore={hasMore}
          handleChooseRow={() => {}}
          styledTableRow={{ cursor: ' default ' }}
        />
      </Stack>
      <DialogConfirm
        isOpen={Boolean(locationDelete)}
        onClose={() => setLocationDelete(undefined)}
        textTitle="Delete Location"
        textContent={`Are you sure you want to delete this location ${locationDelete?.name}?`}
        onSubmit={handleDeleteLocation}
        textButton={'Delete'}
      />
      {clientId && (
        <>
          <ModalReparentLocation
            open={Boolean(locationReparent)}
            location={locationReparent ?? null}
            clientId={clientId}
            onClose={() => setLocationReparent(undefined)}
            onSuccess={() => void asyncGetInitLocations()}
          />
          <ModalEditLocationName
            open={Boolean(locationRename)}
            location={locationRename ?? null}
            onClose={() => setLocationRename(undefined)}
            onSuccess={() => void asyncGetInitLocations()}
          />
        </>
      )}
    </WrapperCreatePage>
  );
};

const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh',
  gap: '20px'
}));
